import { render, staticRenderFns } from "./ListingRelated.vue?vue&type=template&id=2ff3ea5c&scoped=true"
import script from "./ListingRelated.vue?vue&type=script&lang=js"
export * from "./ListingRelated.vue?vue&type=script&lang=js"
import style0 from "./ListingRelated.vue?vue&type=style&index=0&id=2ff3ea5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff3ea5c",
  null
  
)

export default component.exports